import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import ReconcilerGroupList from './reconciler_group_list'
import ReconcilerGroupDetail from './reconciler_group_detail';
import ReconcilerEdit from './recon_edit';
import ReconcilerAddEdit from './recon_add_edit';

class ReconcilerSetting extends Component {
  render() {
    return (
        <Switch>

        <Route path="/settings/reconcilers-group/:group_id/edit/:recon_id" component={ReconcilerEdit}/>
        <Route path="/settings/reconcilers-group/:group_id/add" component={ReconcilerAddEdit}/>
        <Route path="/settings/reconcilers-group/:group_id" component={ReconcilerGroupDetail}/>
        <Route path="/settings/reconcilers-group" component={ReconcilerGroupList}/>
        
        <Redirect from="*" to= "/settings/reconcilers-group"/>
    </Switch>
    );
  }
}

export default ReconcilerSetting;
